import React from "react";
import { HandCoins, Sparkles, Siren } from "lucide-react";

const ITEMS = [
  { icon: HandCoins, label: "Financing Available — Get Repaired, Pay Later" },
  { icon: Sparkles, label: "First-Time Customer Special · $25 OFF Your First Service" },
  { icon: Siren, label: "Emergency Repairs — Call Now for Same-Day Service" },
  { icon: HandCoins, label: "Military Discount Year-Round for Veterans & Active Duty" },
];

export default function Banner() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="promo-banner"
      className="relative bg-[#0B132B] text-white overflow-hidden border-y-2 border-[#D32F2F]"
    >
      <div className="marquee-track flex whitespace-nowrap py-3">
        {loop.map((item, i) => {
          const Icon = item.icon;
          const cycle = i < ITEMS.length ? "a" : "b";
          return (
            <div
              key={`${cycle}-${item.label}`}
              className="flex items-center gap-3 px-8 shrink-0"
              data-testid={`banner-item-${i}`}
            >
              <Icon className="w-4 h-4 text-[#D32F2F]" strokeWidth={2.5} />
              <span className="text-sm font-semibold tracking-wide">
                {item.label}
              </span>
              <span className="text-[#D32F2F] ml-4">◆</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
